import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { GlgSelect } from 'SharedComponents'

const internationalize = (...args) => !window.I18n ? '' : window.I18n.t(...args)

function SingleCriteriaOptions({
  selectedCriteria,
  divisionSource,
  eventDivisions,
  roundDivisions,
  rounds,
  selectedRound,
  roundUsedCourses,
  divisionsByCourse,
  setData,
}) {
  const noRounds = rounds.choices.length === 0
  const copyDivisionOptions = [
    {
      value: 'all_season',
      label: eventDivisions.label,
    },
    {
      value: 'round_specific',
      label: internationalize('divisions.index.add_new_division_or_refill.select_specific_round'),
    }
  ]
  const selectRoundLabel = (
    selectedCriteria === 'copy_division' 
      ? internationalize('divisions.index.add_new_division_or_refill.select_specific_round') 
      : internationalize('divisions.index.add_new_division_or_refill.choose_round') 
  )

  const handleCourseDivisionChange = (courseId, courseName) => {
    let updatedDivisions = divisionsByCourse
    if (updatedDivisions[courseId]) {
      updatedDivisions[courseId] = courseName
    } else {
      updatedDivisions = {
        ...divisionsByCourse,
        [courseId]: courseName,
      }
    }
    setData([ 'create_division', 'divisions_by_course'], updatedDivisions)
  }

  return (
    <>
      { (selectedCriteria === 'single_division' || selectedCriteria === 'copy_division') &&
        <div>
          <div className='btsp_horizontal_dotted_line'/>
          <div className='division_name_text'>
            <label>{ internationalize('divisions.index.add_new_division_or_refill.division_name') }</label>
            <input 
              id='division_name'
              className='focus form-control'
              type='text'
              autoFocus='autofocus'
              onChange={ event => setData([ 'create_division', 'single_division' ,'division_name' ], event.target.value )}
            />
          </div>
        </div>
      }
      { selectedCriteria === 'copy_division' && !noRounds &&
        <div>
          <div className='btsp_horizontal_dotted_line'/>
          <div className='col-xs-12 add-margin-top-20 no-padding'>
            <label>{ internationalize('divisions.index.add_new_division_or_refill.copy_division_from') }</label>
          </div>
          <div className='col-xs-12 no-padding'>
          { copyDivisionOptions.map((option) => (
            <label key={`option_${option.value}`} className={`chip ${divisionSource === option.value ? 'chip-checked' : ''}`} htmlFor={`option_${option.value}`}>
              <input
                id={`option_${option.value}`}
                className='no-radio'
                type='radio'
                name={`${option.value}`}
                value={option.value}
                onChange={ event => setData([ 'create_division', 'division_source' ], event.target.value) }
                checked={divisionSource === option.value}
              />
              <span>{option.label}</span>
            </label>
          ))}
          </div>
        </div>
      }
      { selectedCriteria === 'copy_division' && (noRounds || divisionSource === 'all_season') &&
        <div className='col-xs-12 no-padding'>
          <div className={`btsp_horizontal_dotted_line ${noRounds ? '' : 'hidden'}`}/>
          <div className='col-xs-12 col-sm-6 col-md-5 col-lg-3 add-margin-top-15 no-padding'>
            <label>{ eventDivisions.label }</label>
            <GlgSelect
              key='select_event_division'
              items={ eventDivisions.choices }
              placeholder={ eventDivisions.label }
              value={ eventDivisions.selected }
              noPreFill={true}
              usePortal={true}
              onChange={ value => { 
                setData([ 'create_division', 'copy_event_divisions', 'selected' ], value)
                setData([ 'create_division', 'copy_division_id'], value)
              }}
            />
          </div>
        </div>
      }
      { (selectedCriteria === 'auto_course_pairings' || (selectedCriteria === 'copy_division' && divisionSource === 'round_specific')) &&
        <div className='col-xs-12 no-padding'>
          <div className={`btsp_horizontal_dotted_line ${selectedCriteria === 'copy_division' ? 'hidden' : ''}`}/>
          <div className='col-xs-12 col-sm-6 col-md-5 col-lg-3 add-margin-top-15 no-padding'>
            <label>{selectRoundLabel}</label>
            <GlgSelect
              key='select_round'
              items={ rounds.choices }
              placeholder={ internationalize('divisions.index.add_new_division_or_refill.select_round') }
              value={ rounds.selected }
              noPreFill={true}
              usePortal={true}
              onChange={ value => { setData([ 'create_division', 'rounds', 'selected' ], value) }}
            />
          </div>
        </div>
      }
      { selectedCriteria === 'copy_division' && divisionSource === 'round_specific' && selectedRound && roundDivisions.choices[selectedRound] &&
        <div className='col-xs-12 col-sm-6 col-md-5 col-lg-3 add-margin-top-15 no-padding'>
          <label>{ roundDivisions.label }</label>
          <GlgSelect
            key='select_round_division'
            items={ roundDivisions.choices[selectedRound] }
            placeholder={ internationalize('divisions.index.add_new_division_or_refill.select_round') }
            value={ roundDivisions.selected }
            noPreFill={true}
            usePortal={true}
            onChange={ value => { 
              setData([ 'create_division', 'round_divisions', 'selected' ], value)
              setData([ 'create_division', 'copy_division_id'], value)
            }}
          />
        </div>
      }
      { selectedCriteria === 'auto_course_pairings' && selectedRound && roundUsedCourses[selectedRound] &&
        <div className='col-xs-12 no-padding'>
          <div className='table-responsive btsp_table_container col-xs-12 col-sm-9 col-md-8 col-lg-6 add-margin-top-10 no-padding'>
            <table className='table with_striping tables_v2 table-striped btsp_table'>
              <thead>
                <tr>
                  <th>{ internationalize('divisions.index.add_new_division_or_refill.division_name') }</th>
                  <th>{ internationalize('divisions.index.add_new_division_or_refill.course_name') }</th>
                </tr>
              </thead>
              <tbody>
                { roundUsedCourses[selectedRound].map((course, index) => {
                    return(
                      <tr key={`${course.value}_${index}`}>
                        <td>
                          <input
                            type='text'
                            className='form-control division-name-course'
                            onChange={ event => { handleCourseDivisionChange(course.value, event.target.value) }}
                          />
                        </td>
                        <td>{course.label}</td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </>
  )
}

SingleCriteriaOptions.propTypes = {
  selectedCriteria: PropTypes.string,
  divisionSource: PropTypes.string,
  eventDivisions: PropTypes.object,
  roundDivisions: PropTypes.object,
  rounds: PropTypes.object,
  selectedRound: PropTypes.string,
  roundUsedCourses: PropTypes.object,
  divisionsByCourse: PropTypes.object,
  setData: PropTypes.func,
}

export default SingleCriteriaOptions
